<template>
  <div>
    <form id="contact-form">
      <label>Nom *</label>
      <input type="text" name="username" v-model="atDataForm.username" required />
      <label>Prénom *</label>
      <input type="text" name="user_firstname" v-model="atDataForm.user_firstname" required />
      <label>Email *</label>
      <input type="email" name="user_email" v-model="atDataForm.user_email" required />
      <label>Sujet *</label>
      <input type="text" name="user_subject" v-model="atDataForm.user_subject" required />
      <label>Message *</label>
      <textarea name="user_message" v-model="atDataForm.user_message" required rows="8"></textarea>
      <input type="submit" value="Envoyer" @click="sendMessage" />
    </form>
  </div>
</template>

<script>
import emailjs from 'emailjs-com';

export default {
  name: 'ContactForm',
  data: function() {
    return {
      atDataForm: {
        user_firstname: null,
        username: null,
        user_email: null,
        user_subject: null,
        user_message: null
      }
    };
  },

  methods: {
    checkIfObjectContainsNullValue(object) {
      let isObjectNullLess = true;
      console.log(JSON.stringify(object));
      // eslint-disable-next-line
      Object.entries(object).map(([k, v]) => (!v ? (isObjectNullLess = false) : undefined));
      return isObjectNullLess;
    },

    sendMessage() {
      if (this.checkIfObjectContainsNullValue(this.atDataForm)) {
        emailjs.init('user_1OcpzGXg5pGW0Hbg1tcaf');
        emailjs
          .send('SERVICE_ID', 'TEMPLATE_ID', {
            username: this.atDataForm.username,
            firstname: this.atDataForm.user_firstname,
            email: this.atDataForm.user_email,
            message: this.atDataForm.message,
            subject: this.atDataForm.user_subject,
            msg: this.atDataForm.user_message
          })
          .then(
            function(response) {
              console.log('SUCCESS!', response.status, response.text);
            },
            function(error) {
              console.log('FAILED...', error);
            }
          );
        alert('Votre message a bien été envoyé.');
      } else {
        alert('Veuillez remplir correctement le formulaire');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#contact-form {
  display: flex;
  flex-direction: column;
  background-color: var(--grey);
  padding: 20px;
  border-radius: 3px;

  label {
    text-align: center;
    padding: 0 10px;
    position: relative;
    top: 10px;
    background-color: var(--grey);
    width: 50px;
    left: 20px;
    font-size: 14px;
  }

  input,
  textarea {
    border: 1px solid var(--black);
    border-radius: 3px;
    background-color: transparent;
    padding: 10px;
  }

  input[type='submit'] {
    margin: 10px auto;
    width: 80px;
    border: none;
    background-color: var(--blue);
    color: var(--white);
    text-transform: uppercase;
    cursor: pointer;
  }
}

@media screen and (min-width: 768px) {
  #contact-form {
    padding: 80px 60px;

    textarea {
      height: 200px;
    }
  }
}

@media screen and (min-width: 1024px) {
  #contact-form {
    input[type='text'],
    input[type='email'],
    textarea {
      width: 40vw;
      margin: auto;
    }

    label {
      left: 25vw;
    }
  }
}
</style>
